import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";

const EMPTY = { piattaforma: "", autore: "", titolo: "", url: "", nota: "", flag_italiano: false };
const STATO_CLS = { verificata: "text-emerald-300", esclusa: "text-destructive", candidata_non_verificata: "text-amber-300", raccolta: "text-cyan-300" };

function SourceForm({ initial, onSave, onCancel }) {
  const [f, setF] = useState(initial);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="grid gap-2 rounded-xl border border-border p-3 md:grid-cols-2" data-testid="source-form">
      <Input placeholder="Piattaforma (YouTube, Reddit…)" value={f.piattaforma} onChange={set("piattaforma")} data-testid="source-platform-input" />
      <Input placeholder="Creator / autore" value={f.autore} onChange={set("autore")} data-testid="source-author-input" />
      <Input placeholder="Titolo originale" value={f.titolo} onChange={set("titolo")} data-testid="source-title-input" />
      <Input placeholder="https://…" value={f.url} onChange={set("url")} data-testid="source-url-input" />
      <Input placeholder="Nota interna" value={f.nota} onChange={set("nota")} className="md:col-span-2" />
      <label className="flex items-center gap-2 text-sm"><Checkbox checked={f.flag_italiano} onCheckedChange={(v) => setF({ ...f, flag_italiano: !!v })} data-testid="source-italian-checkbox" /> Creator italiano (non ammesso tra le fonti internazionali)</label>
      <div className="flex gap-2"><Button size="sm" className="rounded-full" onClick={() => onSave(f)} data-testid="source-save-button">Salva</Button><Button size="sm" variant="ghost" onClick={onCancel}>Annulla</Button></div>
    </div>
  );
}

export function SourcesTab({ onChange }) {
  const [list, setList] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/sources").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const call = async (fn) => {
    try { await fn(); toast.success("Fonte aggiornata"); setEdit(null); load(); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  const save = (f) => call(() => (edit === "new" ? api.post("/admin/sources", f) : api.put(`/admin/sources/${edit}`, f)));
  const status = (id, stato) => call(() => api.post(`/admin/sources/${id}/status`, { stato }));
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">Le fonti importate sono SOLO candidate non verificate: i collegamenti originali ai dossier non sono stati ricontrollati e non vengono applicati automaticamente. Verifica link, pertinenza e provenienza internazionale prima di usarle.</p>
      {edit === "new" ? <SourceForm initial={EMPTY} onSave={save} onCancel={() => setEdit(null)} /> :
        <Button onClick={() => setEdit("new")} className="rounded-full" data-testid="source-new-button">Nuova fonte</Button>}
      {list.map((s) => (
        <div key={s.id} className="luma-card space-y-2 text-sm" data-testid={`source-row-${s.id}`}>
          {edit === s.id ? <SourceForm initial={s} onSave={save} onCancel={() => setEdit(null)} /> : (<>
            <p className="text-xs"><b className="font-mono">{s.id}</b> · <span className={STATO_CLS[s.stato]}>{s.stato.replaceAll("_", " ")}</span>{s.flag_italiano && <b className="ml-2 text-destructive">CREATOR ITALIANO</b>}</p>
            <p><b>{s.autore}</b> · {s.piattaforma} — {s.titolo}</p>
            <a href={s.url} target="_blank" rel="noopener noreferrer nofollow" className="break-all text-xs text-primary">{s.url}</a>
            {s.dossier_collegati_originali?.length > 0 && <p className="text-xs text-amber-300">Collegamento originale non verificato: {s.dossier_collegati_originali.join(", ")}</p>}
            {s.nota && <p className="text-xs text-muted-foreground">{s.nota}</p>}
            <div className="flex flex-wrap gap-2">
              <Button size="sm" className="rounded-full" onClick={() => status(s.id, "verificata")} data-testid={`source-verify-${s.id}`}>Verificata</Button>
              <Button size="sm" variant="outline" className="rounded-full" onClick={() => status(s.id, "candidata_non_verificata")}>Candidata</Button>
              <Button size="sm" variant="ghost" className="rounded-full text-destructive" onClick={() => status(s.id, "esclusa")} data-testid={`source-exclude-${s.id}`}>Escludi</Button>
              <Button size="sm" variant="ghost" className="rounded-full" onClick={() => setEdit(s.id)} data-testid={`source-edit-${s.id}`}>Modifica</Button>
            </div>
          </>)}
        </div>
      ))}
    </div>
  );
}
